import { __awaiter, __generator, __read } from "tslib";
import { isFirstUse } from '@office-start/user-storage-service';
import { useEffect, useState } from 'react';
export var useIsFirstUse = function () {
    var _a = __read(useState(false), 2), isFirst = _a[0], setIsFirst = _a[1];
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, isFirstUse()];
                    case 1:
                        result = _a.sent();
                        setIsFirst(result);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    return isFirst;
};
//# sourceMappingURL=useIsFirstUse.js.map